/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useEffect, useState } from 'react';
import {
    LinkButton,
    Icon,
    StackView,
    STACK_ALIGN,
    STACK_GAP,
    Text,
    Popover,
    TooltipPopover,
    X_AXIS,
    Y_AXIS,
    useMeasureClientRect,
} from '@veeam/components';

import { successIconSrc } from '../../icons';

interface CopyToClipboardButtonProps {
    text: string;
    iconSrc: string;
    onClick: (e?: React.MouseEvent) => Promise<string | void>;
}

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
    onClick,
    text,
    iconSrc,
}) => {
    const [message, setMessage] = useState('Copied to clipboard');
    const [isShown, setShown] = useState(false);
    const [ref, target] = useMeasureClientRect();

    const handleClick = (e: React.MouseEvent) => {
        onClick(e).then((message) => {
            if (message) {
                setMessage(message);
            }

            setShown(true);
        });
    };

    useEffect(() => {
        const timer = setTimeout(
            () => setShown(false),
            1000,
        );

        return () => window.clearTimeout(timer);
    }, [isShown]);

    return (
        <LinkButton
            ref={ref}
            iconBefore={iconSrc}
            onClick={handleClick}
        >
            {text}

            <Popover
                isActive={isShown}
                target={target}
                config={[
                    {
                        xAxis: X_AXIS.middle,
                        yAxis: Y_AXIS.outsideTop,
                    },
                    {
                        xAxis: X_AXIS.middle,
                        yAxis: Y_AXIS.outsideBottom,
                    },
                    {
                        xAxis: X_AXIS.middle,
                        yAxis: Y_AXIS.outsideTop,
                    },
                    {
                        xAxis: X_AXIS.middle,
                        yAxis: Y_AXIS.outsideBottom,
                    },
                ]}
                render={popoverRef => (
                    <TooltipPopover
                        ref={popoverRef}
                        renderContent={() => (
                            <StackView align={STACK_ALIGN.center} gap={STACK_GAP.s}>
                                <Icon src={successIconSrc} />
                                <Text>{message}</Text>
                            </StackView>
                        )}
                    />
                )}
            />

        </LinkButton>
    );
};
